<template>
    <div>
        <div class="primarylists list-mobile" v-if="!mobile">
            <div class="titles clear" id="explore">
                <img src="../../../static/images/icon-st.jpg" />
                <div class="title l title-flex">
                    <span style="text-transform: uppercase !important;">{{ $t("manage.attendance") }}</span>
                </div>
            </div>
        </div>
        <div class="manage--main" ref="manageAttendance">
            <div class="header-manage">
                <div class="user-name" id="clm" v-if="mobile && !menu">
                    <template v-if="courseName != null && courseName.search('@') !== -1">{{courseName}}</template>
                    <template v-if="courseName != null && courseName.search('@') == -1">{{courseName}}</template>
                </div>
                <div class="user-namesss" v-if="mobile && menu">
                    <template v-if="courseName != null && courseName.search('@') !== -1">{{courseName}}</template>
                    <template v-if="courseName != null && courseName.search('@') == -1">{{courseName}}</template>
                </div>
                <div class="icon-img-right" @click="showUser()" v-if="mobile">
                    <template v-if="menu"><img src="../../../static/images/khoahoccuatoi-trang.png" /></template>
                    <template v-else><img :src="$CONST.HEADER.IMG.SEARCH" /></template>
                </div>
            </div>
            <!-- left -->
            <left v-on:changeItem="changeItem($event)"></left>
            <!-- main -->
            <template v-if="showContent">
                <contentManage :data="data"></contentManage>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";

    import left from "@/components/manage/left/attendances";
    import contentManage from "@/components/manage/content/attendances";

    export default {
        name: "manageAttendance",
        data() {
            return {
                data: null,
                courseName: null,
                menu: false,
                showContent: true
            };
        },
        components: {
            left,
            contentManage
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile
            }),
        },
        methods: {
            appendLeadingZeroes: function (n) {
                if (n <= 9) {
                    return "0" + n;
                }
                return n;
            },

            // Thay đổi khóa học
            changeItem: function (item) {
                this.menu = false;
                this.courseName = item.courseName;
                this.data = item;

                this.showContent = false;

                this.$nextTick(() => {
                    this.showContent = true;
                });
            },

            // Ẩn / Hiện menu
            showUser: function () {
                this.menu = !this.menu;
                document.getElementsByTagName("body")[this.$CONST.COMMON.NUMBER.ZERO].classList.toggle("show-menu-1");
            },
        },
    };
</script>
<style scoped>
    .exam_btn.btn-login.disable {
        background: #d2d2d2 !important;
        cursor: no-drop;
    }
    .primarylists {
        min-width: 1120px;
        margin-top: 15px!important;
        margin: 0 auto;
        max-width: 1200px;
        width: 100%;
    }
    .nameStudent {
        color: #da251d;
    }
    .user-name {
        margin-left: 4px;
    }
    .user-name.ml {
        margin-left: 50px;
    }
    .user-namesss {
        font-weight: bold;
        padding: 0 5px;
        text-transform: uppercase;
        font-size: 18px;
        color: #fff;
        margin-left: 4px;
    }
    .title-flex {
        display: flex;
        align-items: center;
    }
    .new-btn {
        margin: 0 0px 0 10px !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/manage/attendances.vue